import { Component, OnInit, ViewChild, AfterViewInit, ElementRef } from '@angular/core';
import { MatTableDataSource, MatPaginator, MatSort } from '@angular/material';
import { AppService } from 'src/app/appservice.service';
import { InvoiceData } from 'src/app/_models/invoicedata';
import { InvoiceDataSource } from 'src/app/_helpers/invoice-data-source';
import { InvoicelistService } from 'src/app/_services/invoicelist.service';
import { tap, merge, debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { fromEvent } from 'rxjs';
import * as _moment from 'moment';

const moment = _moment;
@Component({
  selector: 'app-list-invoice',
  templateUrl: './list-invoice.component.html',
  styleUrls: ['./list-invoice.component.css']
})

export class ListInvoiceComponent implements AfterViewInit, OnInit {

  displayedColumns: string[] = ['ordernumber', 'date', 'name', 'grandtotal', 'id'];
  dataSource: InvoiceDataSource;
  selectedSearch = '';
  selecteddate: any;
  selectedinvoiceno = '';
  selectedmobile = '';
  selectedname = '';
  ranges: any = {
    'Today': [moment(), moment()],
    'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
    'Last 7 Days': [moment().subtract(6, 'days'), moment()],
    'Last 30 Days': [moment().subtract(29, 'days'), moment()],
    'This Month': [moment().startOf('month'), moment().endOf('month')],
    'This Year': [moment().subtract(1, 'year').startOf('month'), moment().endOf('month')]
  };
  currentYear = moment().format('YYYY');
  lastYear = moment().subtract(1, 'year').format('YYYY');

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild('input', { static: true }) input: ElementRef;


  constructor(public service: AppService, public invoicelistservice: InvoicelistService) {
    this.ranges['Year ' + this.currentYear] = [moment().startOf('year'), moment().endOf('year')];
    this.ranges['Year ' + this.lastYear] = [moment().subtract(1, 'year').startOf('year'), moment().subtract(1, 'year').endOf('year')];
  }

  ngOnInit() {
    this.dataSource = new InvoiceDataSource(this.invoicelistservice);
    this.dataSource.loadInvoice();
  }

  ngAfterViewInit() {
    // server-side search

    // reset the paginator after sorting
    // this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);

    // this.sort.sortChange
    //   .pipe(
    //     tap(() => this.loadInvoicePage())
    //   )
    //   .subscribe();

    this.paginator.page
      .pipe(
        tap(() => this.loadInvoicePage())
      )
      .subscribe();
  }

  resetLoadinvoicepage() {
    this.paginator.pageIndex = 0;
    this.loadInvoicePage();
  }

  loadInvoicePage() {
    let filter = '';
    if (this.selectedinvoiceno.trim().length > 0) {
      filter += 'ordernumber$' + this.selectedinvoiceno.trim();
    }
    if (this.selectedname.trim().length > 0) {
      filter += '~name$' + this.selectedname.trim();
    }
    if (this.selectedmobile.trim().length > 0) {
      filter += '~mobile$' + this.selectedmobile.trim();
    }
    if (this.selecteddate != null && this.selecteddate.start != null) {
      filter += '~date$' + this.selecteddate.start.format('YYYY-MM-DD HH:mm:ss') + '^' +
        this.selecteddate.end.format('YYYY-MM-DD HH:mm:ss');
    }
    this.dataSource.loadInvoice(
      encodeURIComponent(filter),
      'asc',
      this.paginator.pageIndex,
      this.paginator.pageSize);
  }

  getMonthDateRange(year, month) {
    // month in moment is 0 based, so 9 is actually october, subtract 1 to compensate
    // array is 'year', 'month', 'day', etc
    const startDate = moment([year, month - 1]);

    // Clone the value before .endOf()
    const endDate = moment(startDate).endOf('month');

    // make sure to call toDate() for plain JavaScript date type
    console.log({ start: startDate, end: endDate });
    return { start: startDate, end: endDate };
  }

  ChangeFilter(event) {
    const target = event.source.selected._element.nativeElement;
    this.selectedSearch = event.value;
  }
  delete(id: number) {
    if (confirm(this.service.translate.instant('DeleteConfirm'))) {
      this.service.getRequest('api/invoice/delete?id=' + id.toString()).subscribe(x => {
        if (x.Success) {
          this.service.sendMessage('DeleteSuccess');
        } else {
          this.service.sendMessage('DeleteFailed');
        }
        this.loadInvoicePage();
      }, error => {
        this.service.sendMessage('DeleteFailed');
        this.loadInvoicePage();
      });
    }
  }
}
